export enum Enviroment {
    DEV = "DEV",
    UAT = "UAT",
    PRODUCTION = "Production"
}